import _regeneratorRuntime from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/fabio/projects/internal/moramma/frontend/react-moramma-web/node_modules/@babel/runtime/helpers/esm/inherits";
import fetch from "cross-fetch";
import { Base } from "@timberio/core"; // Namespace the msgpack library
// const msgpack = Msgpack();

export var Node =
/*#__PURE__*/
function (_Base) {
  _inherits(Node, _Base);

  function Node(apiKey, sourceKey, options) {
    var _this;

    _classCallCheck(this, Node);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this, apiKey, sourceKey, options)); // Sync function

    var sync =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(logs) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("".concat(_this._options.endpoint, "/sources/").concat(_this._sourceKey, "/frames"), {
                  method: "POST",
                  headers: {
                    // "Content-Type": "application/msgpack",
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(_this._apiKey),
                    "User-Agent": "timber-js(node)"
                  },
                  // body: logs.map(log => `${log.level}: ${log.message}`).join("\n")
                  // body: msgpack.encode(logsWithSchema).slice()
                  // TODO - using JSON for now; switch to msgpack later
                  body: JSON.stringify(logs)
                });

              case 2:
                res = _context.sent;

                if (!res.ok) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", logs);

              case 5:
                throw new Error(res.statusText);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function sync(_x) {
        return _ref.apply(this, arguments);
      };
    }(); // Set the throttled sync function


    _this.setSync(sync);

    return _this;
  }
  /**
   * Override `Base` log to enable Node.js streaming
   *
   * @param message: string - Log message
   * @param level (LogLevel) - Level to log at (debug|info|warn|error)
   * @param log: (Partial<ITimberLog>) - Initial log (optional)
   * @returns Promise<ITimberLog> after syncing
   */


  _createClass(Node, [{
    key: "log",
    value: function () {
      var _log = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(message, level) {
        var context,
            processedLog,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                _context2.next = 3;
                return _get(_getPrototypeOf(Node.prototype), "log", this).call(this, message, level, context);

              case 3:
                processedLog = _context2.sent;

                // Push the processed log to the stream, for piping
                if (this._writeStream) {
                  this._writeStream.write(JSON.stringify(processedLog) + "\n");
                } // Return the transformed log


                return _context2.abrupt("return", processedLog);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function log(_x2, _x3) {
        return _log.apply(this, arguments);
      }

      return log;
    }()
    /**
     * Pipe JSON stringified `ITimberLog` to a stream after syncing
     *
     * @param stream - Writable|Duplex stream
     */

  }, {
    key: "pipe",
    value: function pipe(stream) {
      this._writeStream = stream;
      return stream;
    }
  }]);

  return Node;
}(Base);